var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bangdan"},[_c('div',{staticClass:"rank"},[_c('Rank',{attrs:{"isShowSelf":false,"province_id":_vm.province_id,"switchPeriod":_vm.period_id,"type":"page"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }